import React, { useState, useRef } from "react";
import { useQuery } from "react-query";
import { DataTable } from "primereact/datatable";
import authApi from "../../../service/IdApi";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

const Promos = () => {
    const [promos, setPromos] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const dataTable = useRef(null);
    const [showDetailsDialog, setShowDetailsDialog] = useState(false);
    const [promoTableState, setPromoTableState] = useState(() => {
        return {
            first: 0,
            rows: 25,
            page: 1,
            sortField: "createdAt",
            sortOrder: -1
        };
    });
    const [selectedPromo, setSelectedPromo] = useState(null);

    const { isLoading, isFetching, isError, data, refetch } = useQuery(["Promos", promoTableState], async () => {
        var body = {};
        body.first = promoTableState.first;
        body.rows = promoTableState.rows;
        body.sortField = promoTableState.sortField;
        body.sortOrder = promoTableState.sortOrder;
        const result = await authApi.post("admin/promos", body);
        setPromos(result.data.promos);
        setTotalRecords(result.data.totalRecords);
        setLoaded(true);
        return data;
    });

    const pageHeader = (
        <PageHeading pageTitle="Admin - Promo Codes">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    const onPage = (event) => {
        setPromoTableState(event);
    };

    const onSort = (event) => {
        setPromoTableState(event);
    };

    const exportCSV = (selectionOnly) => {
        dataTable.current.exportCSV({ selectionOnly });
    };

    const promoCodeBodyTemplate = (rowData) => {
        return (
            <div className="">
                <a href="#" onClick={(e) => rowClicked(e, rowData)}>
                    {rowData.promoCode}
                </a>
            </div>
        );
    };

    const rowClicked = (e, rowData) => {
        e.preventDefault();
        setSelectedPromo(rowData);
        setShowDetailsDialog(true);
    }

    const hideDetailsDialog = () => {
        setShowDetailsDialog(false);
    }

    const expiresAtBodyTemplate = (rowData) => {
        return (
            <span>{new Date(rowData.expiresAt).toLocaleDateString()}</span>
        );
    }

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card pt-3 sm:pt-0">
                    <div className="flex py-3 w-full">
                        <div className="flex flex-row">
                        </div>
                        <div className="flex flex-row flex-grow-1 justify-content-end">
                            <Button type="button" icon="pi pi-file-export" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" label="Export" />
                        </div>
                    </div>
                    <DataTable
                        ref={dataTable}
                        value={promos}
                        dataKey="_id"
                        paginator
                        rows={promoTableState.rows}
                        rowsPerPageOptions={[25, 50, 100]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} promos"
                        emptyMessage="No promos found."
                        lazy
                        first={promoTableState.first}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        onSort={onSort}
                        sortField={promoTableState.sortField}
                        sortOrder={promoTableState.sortOrder}
                        loading={isLoading || isFetching || !loaded}
                    >
                        <Column body={promoCodeBodyTemplate} field="promoCode" header="Promo Code" sortable />
                        <Column field="name" header="Name" sortable />
                        <Column field="type" header="Type" sortable />
                        <Column body={expiresAtBodyTemplate} field="expiresAt" header="Expires On" sortable />
                    </DataTable>
                </div>
                <Dialog
                    visible={showDetailsDialog}
                    style={{ width: '50vw' }}
                    breakpoints={{ '1280px': '75vw', '641px': '95vw' }}
                    header="Promo Details"
                    modal
                    onHide={hideDetailsDialog}
                    className="p-fluid"
                >
                    {selectedPromo && (
                        <div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Promo Code</label>
                                <div className="col">{selectedPromo.promoCode}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Name</label>
                                <div className="col">{selectedPromo.name}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Type</label>
                                <div className="col">{selectedPromo.type}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Expires On</label>
                                <div className="col">{selectedPromo.expiresAt ? new Date(selectedPromo.expiresAt).toLocaleDateString() : "Never"}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Term in Months</label>
                                <div className="col">{selectedPromo.termInMonths}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>User Count</label>
                                <div className="col">{selectedPromo.userCount}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Discount Percent</label>
                                <div className="col">{selectedPromo.percentageOff}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Created On</label>
                                <div className="col">{new Date(selectedPromo.createdAt).toLocaleDateString()}</div>
                            </div>
                        </div>

                    )}
                </Dialog>
            </div>
        </div>
    );
};

export default Promos;
